import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { importProvidersFrom, inject } from '@angular/core';
import { AuthService } from './app/shared/services/auth-service/auth.service';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [...(appConfig.providers || []), AuthService]
})
  .then(appRef => {
    const authService = appRef.injector.get(AuthService);
    authService.init();
  })
  .catch(err => console.error(err));
